import { Stack, StackProps } from "@mui/material";

type PageDetailContainerProps = StackProps & {};
export const PageDetailContainer = ({ ...props }: PageDetailContainerProps) => {
  return (
    <Stack
      {...props}
      direction={"column"}
      spacing={3}
      sx={{
        ...props.sx,
        overflow: "hidden",
      }}
    >
      {props.children}
    </Stack>
  );
};
